export default __webpack_public_path__ + "static/media/payments.bef1ac89.jpeg";